module.exports = __webpack_public_path__ + "static/media/3b_website_logo_coorg_sig.acf81874.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/3b_website_logo_coorg_sig.jpg
// module id = 42
// module chunks = 0